<template>
  <div class="col-md-6">
    <div>
      <ul class="bold name">
        <li>{{brand.name}}</li>
      </ul>
    </div>
    <div class="button bottom-right top-right">
      <button v-if="isProspect" class="btn btn-sm btn-danger" @click="$emit('remove', brand)">Supprimer</button>
      <button v-else class="btn btn-sm btn-warning" @click="$emit('archive', brand)">Archiver</button>
    </div>
    <hr>
  </div>
</template>

<style lang="scss" scoped>
  div {
    position: relative;
    display: inline-block;
  }
  ul {
    list-style-type: none;
    padding: 0;
    margin: 0;
    li {
      line-height: 1.2rem;
    }
  }

  .name {
    font-size: 0.9rem;
  }

  .button {
    // position: relative;
    right: 10px;
  }
</style>

<script type="text/babel">
export default {
  props: ["brand", "isProspect"]
}
</script>



// WEBPACK FOOTER //
// client/components/Customer/Brands/Item.vue